import { __module as e } from "../../../../_virtual/merge.js";
Object.defineProperty(r = e.exports, "__esModule", {
  value: !0
}), r.default = function () {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    r = arguments.length > 1 ? arguments[1] : void 0;
  for (var t in r) void 0 === e[t] && (e[t] = r[t]);
  return e;
}, e.exports = r.default, e.exports.default = r.default;
var r,
  t = e.exports;
export { t as m };